<template>
  <div class="errorDisplay error d-flex align-items-center">
    <span
      v-if="!hideIcon"
      class="icon fa-regular fa-triangle-exclamation mr-2"
    />
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps({
  hideIcon: {
    type: Boolean,
    default: false
  }
});
</script>

<style scoped>
.errorDisplay {
  color: var(--danger);
  font-size: 13px;
  .icon {
    font-size: 24px;
  }
}
</style>
